export const ACCENT_COLORS = [
  "#BD806A", "#A3AD98", "#D6B8AE", "#40352F", "#C69C6D", "#8C9A7B", "#B0724F", "#9B6A7D",
];

export const TIMEZONES = [
  "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
  "America/Phoenix", "America/Anchorage", "Pacific/Honolulu", "America/Toronto",
  "Europe/London", "Europe/Paris", "Australia/Sydney",
];

export const CATEGORIES = ["Bread", "Cookies", "Cakes", "Pastries", "Rolls", "Other"];

export const UNITS = ["grams", "kg", "ounces", "pounds", "cups", "tablespoons", "teaspoons", "milliliters", "liters", "each", "pinch"];

export const ORDER_STATUSES = ["new", "confirmed", "ready", "completed", "canceled"];

export const DIETARY_TAGS = ["Vegan", "Vegetarian", "Gluten-free", "Dairy-free", "Nut-free", "Egg-free", "Organic", "Sugar-free"];
export const COMMON_ALLERGENS = ["Wheat / Gluten", "Eggs", "Milk / Dairy", "Tree nuts", "Peanuts", "Soy", "Sesame", "Fish", "Shellfish"];

const ALLERGEN_KEYWORDS = {
  "Wheat / Gluten": ["flour", "wheat", "bread flour", "all-purpose", "all purpose", "semolina", "spelt", "rye", "barley", "malt", "gluten", "farro", "durum", "graham", "couscous", "bran"],
  "Milk / Dairy": ["milk", "butter", "cream", "buttermilk", "cheese", "yogurt", "yoghurt", "ghee", "whey", "custard", "mascarpone", "ricotta"],
  "Eggs": ["egg", "egg white", "egg yolk", "meringue", "albumen"],
  "Peanuts": ["peanut", "peanut butter", "groundnut"],
  "Tree nuts": ["almond", "almond flour", "walnut", "pecan", "hazelnut", "cashew", "pistachio", "macadamia", "tree nut", "nut flour"],
  "Soy": ["soy", "soya", "soybean", "tofu", "edamame", "soy lecithin", "tamari", "miso"],
  "Sesame": ["sesame", "tahini"],
  "Fish": ["fish", "anchovy", "salmon", "tuna", "cod"],
  "Shellfish": ["shrimp", "prawn", "crab", "lobster", "clam", "mussel", "oyster", "scallop", "shellfish"],
};

// Suggest allergens from ingredient names. Whole-word matching so "eggplant" won't trigger Eggs. Advisory only.
export const suggestAllergens = (ingredients = []) => {
  const found = new Set();
  for (const ing of ingredients) {
    const name = String((ing && ing.name) || "").toLowerCase();
    for (const [allergen, kws] of Object.entries(ALLERGEN_KEYWORDS)) {
      const hit = kws.some((kw) => {
        const esc = kw.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        return new RegExp(`(^|[^a-z])${esc}(s)?([^a-z]|$)`).test(name);
      });
      if (hit) found.add(allergen);
    }
  }
  return Array.from(found);
};
export const PAYMENT_STATUSES = ["unpaid", "deposit_paid", "paid", "not_required"];

export const STATUS_LABEL = {
  new: "New", confirmed: "Confirmed", ready: "Ready", completed: "Completed", canceled: "Canceled",
  unpaid: "Unpaid", paid: "Marked paid", deposit_paid: "Deposit paid", not_required: "Payment not required",
  draft: "Draft", open: "Open for ordering", closed: "Closed",
};

export const STATUS_COLOR = {
  new: "bg-terracotta/15 text-terracotta",
  confirmed: "bg-sage/25 text-cocoa",
  ready: "bg-rose/30 text-cocoa",
  completed: "bg-cocoa/10 text-cocoa/70",
  canceled: "bg-destructive/10 text-destructive",
  draft: "bg-cocoa/10 text-cocoa/60",
  open: "bg-sage/25 text-cocoa",
  closed: "bg-cocoa/10 text-cocoa/70",
  deposit_paid: "bg-amber-100 text-amber-800",
};
